import analytic from '@/scripts/libs/analytic';
import { FilmQuotaServiceListeners, ConsumptionChangeReason, FilmQuotaService } from '@/scripts/services/filmQuotaService';

type ChangeListener = FilmQuotaServiceListeners['consumptionChange']

const handleQuotaConsumed: ChangeListener = (reason, newInfo) => {
  const consumedAtData = (
    newInfo.firstConsumedAt == null
      // Logically, firstConsumedAt is never null.
      // Consumption info is likely corrupted/tampered if this is null.
      ? null
      : new Date(newInfo.firstConsumedAt).toISOString()
  );

  analytic.send({
    customProperties: {
      ga: false,
      snowplow: {
        selfDescribingEvent: {
          schema: 'iglu:com.viddsee/film_quota_consumption/jsonschema/1-0-0',
          data: {
            // eslint-disable-next-line @typescript-eslint/camelcase
            consumed_count: newInfo.consumedCount,
            // eslint-disable-next-line @typescript-eslint/camelcase
            first_consumed_at: consumedAtData,
          },
        },
      },
    },
  });
};

const handleQuotaCorrupted: ChangeListener = () => {
  analytic.send({
    category: 'film-quota',
    action: 'resetted:corrupted-consumption-info',
  });
};

const changeListener: ChangeListener = (reason, newInfo, oldInfo) => {
  switch (reason) {
    case ConsumptionChangeReason.Consumed: {
      return handleQuotaConsumed(reason, newInfo, oldInfo);
    }
    case ConsumptionChangeReason.Corrupted: {
      return handleQuotaCorrupted(reason, newInfo, oldInfo);
    }
    default:
  }
};

export const registerListener = (filmQuotaService: FilmQuotaService) => {
  filmQuotaService.on('consumptionChange', changeListener);
};
